/* tjs <- string-case.ts */

/* line 1 */
export function camelToKabob(s) {
    return s.replace(/[A-Z]/g, (c) => {
        return `-${c.toLocaleLowerCase()}`;
    });
}
camelToKabob.__tjs = {
  "params": {
    "s": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "string-case.ts:4"
}

/* line 7 */
export function kabobToCamel(s) {
    return s.replace(/-([a-z])/g, (_, c) => {
        return c.toLocaleUpperCase();
    });
}
kabobToCamel.__tjs = {
  "params": {
    "s": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "string-case.ts:11"
}